export const GET_CASHBOOK_HEAD_LIST = "GET_CASHBOOK_HEAD_LIST"
export const GET_CASHBOOK_HEAD_LIST_SUCCESS = "GET_CASHBOOK_HEAD_LIST_SUCCESS"

export const SAVE_CASHBOOK_HEAD = "SAVE_CASHBOOK_HEAD"
export const SAVE_CASHBOOK_HEAD_SUCCESS = "SAVE_CASHBOOK_HEAD_SUCCESS"

export const EDIT_CASHBOOK_HEAD_ID = "EDIT_CASHBOOK_HEAD_ID"
export const EDIT_CASHBOOK_HEAD_ID_SUCCESS = "EDIT_CASHBOOK_HEAD_ID_SUCCESS"

export const UPDATE_CASHBOOK_HEAD_ID = "UPDATE_CASHBOOK_HEAD_ID"
export const UPDATE_CASHBOOK_HEAD_ID_SUCCESS = "UPDATE_CASHBOOK_HEAD_ID_SUCCESS"

export const DELETE_CASHBOOK_HEAD_ID = "DELETE_CASHBOOK_HEAD_ID"
export const DELETE_CASHBOOK_HEAD_ID_SUCCESS = "DELETE_CASHBOOK_HEAD_ID_SUCCESS"

export const CASHBOOK_HEAD_API_ERROR_ACTION = "CASHBOOK_HEAD_API_ERROR_ACTION"